import * as React from "react";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { getAuthorFromCityStayedAtHotelText, getPostedAgoText } from "../hotelRecentReviewsUtils";

interface ReviewAuthorAndPostedDateProps {
  authorName: string;
  authorLocation: string;
  hotelName: string;
  datePosted: Date;
  index: number;
}

export const LocalizedReviewAuthorAndPostedDate = (props: ReviewAuthorAndPostedDateProps) => (
  <Viewport>
    <ViewSmall>
      <div className="uitk-cell all-y-padding-one">
        <div className="uitk-type-bold">
          {getAuthorFromCityStayedAtHotelText(props.authorName, props.authorLocation, props.hotelName)}
        </div>
        <div id={`postedText-${props.index}`}>{getPostedAgoText(props.datePosted)}</div>
      </div>
    </ViewSmall>
    <ViewMedium>
      <div className="uitk-cell all-y-padding-one">
        <div className="uitk-type-200">
          {getAuthorFromCityStayedAtHotelText(props.authorName, props.authorLocation, props.hotelName)}
        </div>
        <div className="uitk-type-200" id={`postedText-${props.index}`}>
          {getPostedAgoText(props.datePosted)}
        </div>
      </div>
    </ViewMedium>
  </Viewport>
);
